import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const businessExternalOperatorsPageBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [{ label: '/', to: '/' }];

export const childrenBusinessExternalOperatorsPageBreadcrumbs = (
  _navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Sistema de envíos', to: '/business-external-operators' },
];

export const childrenShippingsExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: 'Envíos',
    onClick: () => navigate('/business-external-operators/shippings'),
  },
];

export const childrenDriversExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: 'Conductores',
    onClick: () => navigate('/business-external-operators/drivers'),
  },
];

export const childrenBatchCheckpointsExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [...childrenBusinessExternalOperatorsPageBreadcrumbs(navigate)];

export const childrenAmendmentsExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [...childrenBusinessExternalOperatorsPageBreadcrumbs(navigate)];

export const amendmentHistoryExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenAmendmentsExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: 'Enmiendas',
    onClick: () => navigate('/business-external-operators/amendments'),
  },
];

export const childrenLogisticsManagementExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenBusinessExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: 'Gestión Logística',
    onClick: () => navigate('/business-external-operators/logistics-management'),
  },
];

export const childrenServicesExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenLogisticsManagementExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: 'Servicios',
    onClick: () =>
      navigate('/business-external-operators/logistics-management/services'),
  },
];

export const childrenZonesExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenLogisticsManagementExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: 'Zonas',
    onClick: () =>
      navigate('/business-external-operators/logistics-management/zones'),
  },
];

export const childrenCommercesExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  ...childrenLogisticsManagementExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: 'Comercios',
    onClick: () =>
      navigate('/business-external-operators/logistics-management/commerces'),
  },
];

export const childrenBranchCommerceExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction,
  commerceId: string,
  commerceName?: string
): NavigateLink[] => [
  ...childrenCommercesExternalOperatorsPageBreadcrumbs(navigate),
  {
    label: commerceName || 'Comercio',
    onClick: () =>
      navigate(
        `/business-external-operators/logistics-management/commerce/${commerceId}`
      ),
  },
];

export const childrenBranchesExternalOperatorsPageBreadcrumbs = (
  navigate: NavigateFunction,
  commerceId: string,
  commerceName?: string
): NavigateLink[] => [
  ...childrenBranchCommerceExternalOperatorsPageBreadcrumbs(
    navigate,
    commerceId,
    commerceName
  ),
  {
    label: 'Sucursales',
    onClick: () =>
      navigate(
        `/business-external-operators/logistics-management/commerce/${commerceId}/branches`
      ),
  },
];
